import React from 'react'
import classnames from 'classnames/bind'
// @ts-ignore no types
import { Divider, Grid } from '@adc/ui-adc'
import * as graph from '@adc/sdk'
import { ContentMarketingAttribute } from '@adc/sdk/types'
import { useListingContext } from '../../context/listing'
import RichTextView from '../../components/richTextView'
import SectionPanel from '../../components/sectionPanel'
// @ts-ignore no types
import styles from './index.scss'
const cx = classnames.bind(styles)

const TransactionDetails = () => {
  const { listing } = useListingContext()
  const auctioneerInfo = listing.marketing_attributes?.find(
    item =>
      item?.attribute_type ===
      graph.enums.MarketingAttributeType.AuctioneerLicensing
  ) as ContentMarketingAttribute
  const transactionDetails = listing.marketing_attributes?.find(
    item =>
      item?.attribute_type ===
      graph.enums.MarketingAttributeType.TransactionDetails
  ) as ContentMarketingAttribute

  return (
    (!!transactionDetails?.message || !!auctioneerInfo) && (
      <SectionPanel
        title='Transaction Details'
        elmId='transaction_details'
        compact='top-only'
      >
        <Grid>
          <Grid.Column computer={16} tablet={16} mobile={16}>
            {transactionDetails?.message && (
              <RichTextView
                content={transactionDetails?.message}
                elmId='transaction_cms_info'
              />
            )}
            {!!transactionDetails?.message && !!auctioneerInfo && <Divider />}
            <div className={cx('auctioneer-property-info')}>
              {!!auctioneerInfo && (
                <p>
                  <strong>Auctioneer Licensing Information</strong>
                </p>
              )}
              {auctioneerInfo?.message && (
                <RichTextView
                  content={auctioneerInfo?.message}
                  elmId='auctioneer_info'
                />
              )}
            </div>
          </Grid.Column>
        </Grid>
      </SectionPanel>
    )
  )
}

export default TransactionDetails
